import UsersDataTable from "./UsersDataTable";

export default UsersDataTable;
